import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from "@chakra-ui/react";

interface BaseModalProps {
  isOpen: boolean;
  onClose: () => any;
  title: string;
  children?: React.ReactNode;
  footerChildren?: React.ReactNode;
  closeOnOverlayClick?: boolean;
  size?:
    | (string & Record<string, unknown>)
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "4xl"
    | "5xl"
    | "6xl"
    | "full";
}

function BaseModal({
  isOpen,
  onClose,
  title,
  children,
  footerChildren,
  size,
  closeOnOverlayClick = false,
}: BaseModalProps) {
  return (
    <>
      <Modal
        size={size}
        closeOnOverlayClick={closeOnOverlayClick}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader> {title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{children}</ModalBody>
          <ModalFooter>{footerChildren}</ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default BaseModal;
